import { BUTTON_SIZES } from '@elliemae/ds-button-v2';
import { RecentDocuments } from '@elliemae/ds-icons';
import { useContext, useMemo } from 'react';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import { ControlledDateTimePickerDatatestid } from '../../../constants/index.js';
import { StyledIconTriggerButton } from './Styleds.js';
import { TimeWheelContext } from './TimeWheelContext.js';

// we memoize the Icon for maximum optimization
// this is particularly useful due to how usePopper needs to check the references
// since references are saved in a immutable way, we make sure to shortcircuit useless-re-renders
export const TimeWheelIconTrigger = (): JSX.Element => {
  const { handleSetTriggerRef, handleToggleTimePicker, handlePickerIconKeyDown } = useContext(TimeWheelContext);
  const {
    props: { disabled, tabIndex },
    getProps,
    ariaCurrentValueForInputs,
  } = useContext(ControlledDateTimePickerContext);
  return useMemo(
    () => (
      <StyledIconTriggerButton
        aria-label={`time picker context menu trigger, ${ariaCurrentValueForInputs}`}
        buttonType="icon"
        size={BUTTON_SIZES.M}
        innerRef={handleSetTriggerRef}
        tabIndex={tabIndex}
        onClick={handleToggleTimePicker}
        onKeyDown={handlePickerIconKeyDown}
        data-testid={ControlledDateTimePickerDatatestid.PICKER_ICONS.TIMEWHEEL}
        disabled={disabled}
        type="button"
        getOwnerProps={getProps}
      >
        <RecentDocuments color={disabled ? ['neutral', '500'] : ['brand-primary', '800']} />
      </StyledIconTriggerButton>
    ),
    [
      ariaCurrentValueForInputs,
      disabled,
      getProps,
      handlePickerIconKeyDown,
      handleSetTriggerRef,
      handleToggleTimePicker,
      tabIndex,
    ],
  );
};
